module.exports = __webpack_public_path__ + "img/yilianGl3.46bc1f2b.png";